import { useEffect } from 'react';

import { MANAGER_ONLY_VIEWS, VIEW_TO_PATH } from '../routes';

// Garde-fou : une page manager-only ouverte par un compte non-manager retombe sur Timeline.
export function useManagerOnlyGuard({ navigate, profile, appState, viewAsMemberId }) {
  useEffect(() => {
    if (!profile) return;
    const mgr = profile.role === 'manager' && !viewAsMemberId;
    if (MANAGER_ONLY_VIEWS.includes(appState.view) && !mgr)
      navigate(VIEW_TO_PATH.timeline, { replace: true });
  }, [profile, viewAsMemberId, appState.view]);
}
